exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slither-enter-active,.slither-leave-active{transition:transform .5s}.slither-enter,.slither-leave-to{transform:translateX(100%)}.slither-enter-to,.slither-leave{transform:translateX(0)}", ""]);

// exports
